import React from 'react';

export default () => (
	<svg
		id="b43bf247-fd00-4c66-86de-2f4e4870ba29"
		data-name="Layer 1"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		width="500"
		viewBox="0 0 1113.58 784.41"
	>
		<defs>
			<linearGradient
				id="e697e668-bf6d-4d5c-9412-9fae30629717"
				x1="990.77"
				y1="609.55"
				x2="1147.32"
				y2="609.55"
				gradientTransform="matrix(-1, 0, 0, 1, 2040, 0)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="gray" stopOpacity="0.25" />
				<stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
				<stop offset="1" stopColor="gray" stopOpacity="0.1" />
			</linearGradient>
		</defs>
		<title>visual data</title>
		<ellipse
			cx="965"
			cy="767.42"
			rx="64"
			ry="16.99"
			fill="#3f51b5"
			opacity="0.1"
		/>
		<path
			d="M1113.76,752.68c-24.35,20.2-59,28.56-92.51,33.84l-5.64.86c-35,5.22-70.39,8-105.9,9.69-19,.92-38,1.57-57,2.15l-14.89.44q-29,.86-58.11,1.69-28.5.81-57,1.52-36.5.89-73,1.48-28.5.45-57,.62-36.51.21-73-.14-28.52-.29-57-1-36.52-.94-73-2.75-24.76-1.21-49.49-2.91l-7.51-.53c-70.77-5.1-142.81-14.25-204.74-43.17l-1.67-.79c-.83-.39-1.66-.78-2.49-1.19a224.11,224.11,0,0,1-32.56-19.09c-18.31-13.06-33.43-29-41.42-47.91-12.52-29.66-5.9-63,8.4-92S94,538.31,112.57,511c5.44-8,10.6-16.3,15.4-24.81,30-53.37,44.88-115.13,13.43-166.56a228.58,228.58,0,0,0-13.43-19c-7.67-10-15.47-20-20.74-31.07-12.29-25.76-9.65-54.73-5.17-82.25,6-36.59,17-76,51.38-98.86,35.67-23.74,86.3-22.54,130.57-14,68.83,13.19,132.36,40.8,196.49,65.7s131.31,47.67,201.82,50.12a322.09,322.09,0,0,0,45.38-1.65h0a287.81,287.81,0,0,0,59.12-12.45c27.75-9.14,53-22.89,71.72-42,40.15-40.85,115.6-43.94,170-19.27,51.91,23.54,85.48,73.36,83,123.12-2.82,55.39-44.3,100.93-82.31,147.64-4.61,5.66-9.16,11.34-13.59,17.06q-3.71,4.79-7.28,9.6h0c-4.17,5.66-8.2,11.35-12,17.11-19.42,29.53-33.15,65-19.78,96.88,7.5,17.85,21.81,31.47,39.06,43.36,38.65,26.63,92,44.55,116,81.83C1152.32,683.63,1144.66,727,1113.76,752.68Z"
			transform="translate(-43.21 -57.79)"
			fill="#3f51b5"
			opacity="0.1"
		/>
		<g opacity="0.1">
			<path
				d="M598.71,607.14q.06,1.41.21,2.76,11.67-4.65,22.91-10a18.57,18.57,0,0,0,10.59-5.18c2.19-1.1,4.37-2.25,6.53-3.4a26.82,26.82,0,0,0-1.66-3c-4.21-6.65-10.61-10.81-17.66-10.58s-13.15,4.8-16.92,11.69A34.46,34.46,0,0,0,598.71,607.14Z"
				transform="translate(-43.21 -57.79)"
				fill="#3f3d56"
			/>
			<path
				d="M597.56,572.17a34.57,34.57,0,0,0,5.15,17.32c4.22,6.63,10.62,10.79,17.67,10.56.49,0,1-.07,1.45-.11a18.57,18.57,0,0,0,10.59-5.18,25.47,25.47,0,0,0,4.87-6.38,35.82,35.82,0,0,0-1.14-35c-4.22-6.65-10.62-10.81-17.67-10.58s-13.14,4.8-16.91,11.69A34.47,34.47,0,0,0,597.56,572.17Z"
				transform="translate(-43.21 -57.79)"
				fill="#3f3d56"
			/>
			<ellipse
				cx="618.28"
				cy="536.48"
				rx="21.87"
				ry="28.63"
				transform="translate(-60.47 -37.23) rotate(-1.88)"
				fill="#3f3d56"
			/>
			<ellipse
				cx="617.13"
				cy="501.51"
				rx="21.87"
				ry="28.63"
				transform="translate(-59.32 -37.28) rotate(-1.88)"
				fill="#3f3d56"
			/>
			<ellipse
				cx="615.99"
				cy="466.54"
				rx="21.87"
				ry="28.63"
				transform="translate(-58.18 -37.34) rotate(-1.88)"
				fill="#3f3d56"
			/>
			<path
				d="M690,224.56a104.08,104.08,0,0,0,7.74-12.25L640,204.77l62.12-1.58a104.89,104.89,0,0,0-.72-83l-81.91,45.95,75-59A104.75,104.75,0,1,0,525.38,230a105.16,105.16,0,0,0-11.31,19.48l75.81,36.28-80.36-24.06a104.8,104.8,0,0,0,20.11,97.75A104.74,104.74,0,1,0,694.19,354,104.77,104.77,0,0,0,690,224.56Z"
				transform="translate(-43.21 -57.79)"
				fill="#3f51b5"
			/>
			<path
				d="M505.1,295.42a104.26,104.26,0,0,0,24.53,64A104.74,104.74,0,1,0,694.19,354C707.64,335.74,504.72,283.67,505.1,295.42Z"
				transform="translate(-43.21 -57.79)"
				opacity="0.1"
			/>
		</g>
		<g opacity="0.1">
			<path
				d="M369.39,791.35c0,.66-.07,1.32-.15,2q-8.3-3.3-16.31-7.07a13.21,13.21,0,0,1-7.54-3.67q-2.34-1.19-4.65-2.42a18.9,18.9,0,0,1,1.18-2.12c3-4.74,7.54-7.7,12.56-7.54s9.36,3.4,12,8.3A24.5,24.5,0,0,1,369.39,791.35Z"
				transform="translate(-43.21 -57.79)"
				fill="#3f3d56"
			/>
			<path
				d="M370.17,766.46a24.59,24.59,0,0,1-3.64,12.33c-3,4.72-7.55,7.69-12.56,7.53l-1-.08a13.21,13.21,0,0,1-7.54-3.67,18,18,0,0,1-3.47-4.54,25.53,25.53,0,0,1,.78-24.89c3-4.74,7.55-7.7,12.56-7.54s9.36,3.4,12.05,8.3A24.5,24.5,0,0,1,370.17,766.46Z"
				transform="translate(-43.21 -57.79)"
				fill="#3f3d56"
			/>
			<ellipse
				cx="355.4"
				cy="741.08"
				rx="20.37"
				ry="15.56"
				transform="translate(-439.72 1015.15) rotate(-88.19)"
				fill="#3f3d56"
			/>
			<ellipse
				cx="356.18"
				cy="716.19"
				rx="20.37"
				ry="15.56"
				transform="translate(-414.09 991.83) rotate(-88.19)"
				fill="#3f3d56"
			/>
			<ellipse
				cx="356.97"
				cy="691.3"
				rx="20.37"
				ry="15.56"
				transform="translate(-388.45 968.51) rotate(-88.19)"
				fill="#3f3d56"
			/>
			<path
				d="M304.12,519.17a75.81,75.81,0,0,1-5.53-8.71L339.67,505,295.46,504a74.64,74.64,0,0,1,.44-59.08l58.33,32.63L300.81,435.6a74.54,74.54,0,1,1,120.42,87.26,74.43,74.43,0,0,1,8.07,13.86L375.38,562.6l57.17-17.2A74.65,74.65,0,0,1,418.33,615a74.54,74.54,0,1,1-117.12-3.7,74.54,74.54,0,0,1,2.91-92.12Z"
				transform="translate(-43.21 -57.79)"
				fill="#3f51b5"
			/>
			<path
				d="M435.72,569.43A74.27,74.27,0,0,1,418.33,615a74.54,74.54,0,1,1-117.12-3.7C291.62,598.3,436,561.06,435.72,569.43Z"
				transform="translate(-43.21 -57.79)"
				opacity="0.1"
			/>
		</g>
		<g opacity="0.1">
			<path
				d="M890.16,661.3c0,.67-.07,1.32-.14,2q-8.31-3.3-16.31-7.07a13.26,13.26,0,0,1-7.55-3.67c-1.55-.79-3.11-1.6-4.65-2.42a20.63,20.63,0,0,1,1.18-2.12c3-4.74,7.54-7.7,12.56-7.54s9.36,3.4,12,8.3A24.5,24.5,0,0,1,890.16,661.3Z"
				transform="translate(-43.21 -57.79)"
				fill="#3f3d56"
			/>
			<path
				d="M891,636.41a24.59,24.59,0,0,1-3.65,12.33c-3,4.72-7.54,7.69-12.56,7.53l-1-.08a13.26,13.26,0,0,1-7.55-3.67,18.32,18.32,0,0,1-3.47-4.54,25.53,25.53,0,0,1,.78-24.89c3-4.73,7.55-7.7,12.56-7.54s9.37,3.4,12.05,8.3A24.5,24.5,0,0,1,891,636.41Z"
				transform="translate(-43.21 -57.79)"
				fill="#3f3d56"
			/>
			<ellipse
				cx="876.17"
				cy="611.03"
				rx="20.37"
				ry="15.56"
				transform="translate(194.62 1409.71) rotate(-88.19)"
				fill="#3f3d56"
			/>
			<ellipse
				cx="876.96"
				cy="586.14"
				rx="20.37"
				ry="15.56"
				transform="translate(220.26 1386.4) rotate(-88.19)"
				fill="#3f3d56"
			/>
			<ellipse
				cx="877.74"
				cy="561.26"
				rx="20.37"
				ry="15.56"
				transform="translate(245.89 1363.08) rotate(-88.19)"
				fill="#3f3d56"
			/>
			<path
				d="M824.89,389.12a73.57,73.57,0,0,1-5.52-8.71L860.45,375l-44.21-1.07a74.7,74.7,0,0,1,.43-59.08L875,347.48l-53.42-41.93A74.55,74.55,0,1,1,942,392.81a74.39,74.39,0,0,1,8.06,13.86l-53.92,25.88,57.17-17.2a74.57,74.57,0,0,1-14.22,69.59A74.53,74.53,0,1,1,822,481.24a74.54,74.54,0,0,1,2.91-92.12Z"
				transform="translate(-43.21 -57.79)"
				fill="#3f51b5"
			/>
			<path
				d="M956.5,439.38a74.2,74.2,0,0,1-17.4,45.56A74.53,74.53,0,1,1,822,481.24C812.4,468.25,956.76,431,956.5,439.38Z"
				transform="translate(-43.21 -57.79)"
				opacity="0.1"
			/>
		</g>
		<ellipse cx="193.5" cy="750.89" rx="57.01" ry="10.96" fill="#3f51b5" />
		<ellipse cx="192.55" cy="746.23" rx="6.64" ry="8.69" fill="#3f3d56" />
		<ellipse cx="192.55" cy="735.61" rx="6.64" ry="8.69" fill="#3f3d56" />
		<ellipse cx="192.55" cy="724.99" rx="6.64" ry="8.69" fill="#3f3d56" />
		<ellipse cx="192.55" cy="714.37" rx="6.64" ry="8.69" fill="#3f3d56" />
		<ellipse cx="192.55" cy="703.75" rx="6.64" ry="8.69" fill="#3f3d56" />
		<ellipse cx="192.55" cy="693.13" rx="6.64" ry="8.69" fill="#3f3d56" />
		<ellipse cx="192.55" cy="682.51" rx="6.64" ry="8.69" fill="#3f3d56" />
		<path
			d="M260.61,667.62a32.32,32.32,0,0,0,2.47-3.64l-17.44-2.87,18.86.15a31.89,31.89,0,0,0,.61-25.2L239.8,649.19,263.14,632a31.8,31.8,0,1,0-52.52,35.59,32,32,0,0,0-3.62,5.8l22.64,11.76-24.14-8.1a31.82,31.82,0,0,0,5.12,29.86,31.8,31.8,0,1,0,50,0,31.82,31.82,0,0,0,0-39.32Z"
			transform="translate(-43.21 -57.79)"
			fill="#3f51b5"
		/>
		<path
			d="M203.82,687.28a31.67,31.67,0,0,0,6.8,19.66,31.8,31.8,0,1,0,50,0C264.87,701.53,203.82,683.71,203.82,687.28Z"
			transform="translate(-43.21 -57.79)"
			opacity="0.1"
		/>
		<path
			d="M389.71,575v226q-24.76-1.21-49.49-2.91l-7.51-.53V575a8.82,8.82,0,0,1,8.82-8.82h39.36A8.82,8.82,0,0,1,389.71,575Z"
			transform="translate(-43.21 -57.79)"
			fill="#3f3d56"
		/>
		<path
			d="M462.71,803.81V424a8.82,8.82,0,0,1,8.82-8.82h39.36a8.82,8.82,0,0,1,8.82,8.82v380.8Z"
			transform="translate(-43.21 -57.79)"
			fill="#3f3d56"
		/>
		<path
			d="M592.71,805V503a8.82,8.82,0,0,1,8.82-8.82h39.36a8.82,8.82,0,0,1,8.82,8.82V804.35Z"
			transform="translate(-43.21 -57.79)"
			fill="#3f3d56"
		/>
		<path
			d="M779.71,279V801.35q-28.5.81-57,1.52V279a8.82,8.82,0,0,1,8.82-8.82h39.36A8.82,8.82,0,0,1,779.71,279Z"
			transform="translate(-43.21 -57.79)"
			fill="#3f3d56"
		/>
		<path
			d="M909.71,384v413c-19,.92-38,1.57-57,2.15V384a8.82,8.82,0,0,1,8.82-8.82h39.36A8.82,8.82,0,0,1,909.71,384Z"
			transform="translate(-43.21 -57.79)"
			fill="#3f3d56"
		/>
		<polyline
			points="318.5 385.41 448.5 240.41 578.5 313.41 708.5 89.41 838.5 196.41"
			fill="none"
			stroke="#3f3d56"
			strokeLinecap="round"
			strokeMiterlimit="10"
			strokeWidth="7"
		/>
		<circle cx="318" cy="385.41" r="28" fill="#3f51b5" />
		<circle cx="448" cy="240.41" r="28" fill="#3f51b5" />
		<circle cx="578" cy="313.41" r="28" fill="#3f51b5" />
		<circle cx="708" cy="89.41" r="28" fill="#3f51b5" />
		<circle cx="958" cy="327.41" r="28" fill="#3f51b5" />
		<ellipse
			cx="233.68"
			cy="722.61"
			rx="18.68"
			ry="3.16"
			fill="#3f51b5"
			opacity="0.1"
		/>
		<path
			d="M264.35,765.73s10.65-.33,13.86-2.62,16.39-5,17.19-1.35,16,18.24,4,18.34-27.95-1.88-31.15-3.83S264.35,765.73,264.35,765.73Z"
			transform="translate(-43.21 -57.79)"
			fill="#a8a8a8"
		/>
		<path
			d="M299.59,778.82c-12,.1-27.94-1.87-31.15-3.82-2.44-1.49-3.41-6.82-3.74-9.28h-.35s.67,8.59,3.88,10.54,19.12,3.93,31.15,3.83c3.47,0,4.67-1.26,4.6-3.09C303.5,778.11,302.18,778.8,299.59,778.82Z"
			transform="translate(-43.21 -57.79)"
			opacity="0.2"
		/>
		<ellipse
			cx="1063.8"
			cy="749.41"
			rx="34.31"
			ry="5.8"
			fill="#3f51b5"
			opacity="0.1"
		/>
		<path
			d="M1084,780.25s19.57-.6,25.47-4.8,30.1-9.21,31.56-2.48,29.42,33.5,7.32,33.68-51.34-3.44-57.23-7S1084,780.25,1084,780.25Z"
			transform="translate(-43.21 -57.79)"
			fill="#a8a8a8"
		/>
		<path
			d="M1148.72,804.31c-22.1.18-51.34-3.44-57.23-7-4.48-2.73-6.27-12.53-6.87-17l-.65,0s1.24,15.79,7.12,19.37,35.14,7.21,57.23,7c6.38,0,8.58-2.32,8.46-5.68C1155.89,803,1153.46,804.27,1148.72,804.31Z"
			transform="translate(-43.21 -57.79)"
			opacity="0.2"
		/>
		<path
			d="M892.81,402.37a9,9,0,0,0,2,4.77c1.45,1.64,3.62,2.39,5.57,3.37a22,22,0,0,1,10.76,12.37c3.33,9.72,3.76,20,8,29.38s9.22,18.39,12.88,28c2.08,5.45,3.74,11.12,6.79,16.08a24.94,24.94,0,0,0,5.57,6.41c-.23,3.52-.32,7-.3,10.52a4,4,0,0,1,3.42,1.8,10.41,10.41,0,0,1,1.5,3.75c1.37,5.67-.32,11.71.91,17.41a88.56,88.56,0,0,1-3,47.64c-1.37,3.88-3.09,16.72-1.63,20.57,5.44-.55,10.26,2.79,15.35,5a21.12,21.12,0,0,1-.72,9c-1.83,5.27-1.82,11-1.79,16.57l.25,41.26c0,5.23.07,10.53,1.38,15.6,1.49,5.71,4.62,11.53,4.52,17.43C964,722,970,734.1,969.52,746.7c-.09,2.42-.42,4.82-.65,7.22a82.14,82.14,0,0,0,.48,19.19c1.82,12.66,6.63,25.11,5.43,37.84-.08.86-.37,2-1.18,2.33,1,1.13,2.06,2.25,3.14,3.32a2.85,2.85,0,0,1-.87.91,8.84,8.84,0,0,1-3.82,1,8.09,8.09,0,0,0-4.37,1.42,6.29,6.29,0,0,0-1.82,3.34,9,9,0,0,0,1.2,7.48,8.35,8.35,0,0,0,3.39,2.54c4.62,2,9.92.55,14.74-.91l18.88-5.72a6.36,6.36,0,0,0,3.07-1.6,3.36,3.36,0,0,0,.75-1.62c4.17,1,8.75-.23,13-1.5l18.88-5.73a6.27,6.27,0,0,0,3.07-1.6,3.66,3.66,0,0,0,.77-3c.14-.06.28-.1.42-.17,1.44-.65,3-1.92,2.65-3.45-.25-1-1.25-1.58-1.68-2.5a3.61,3.61,0,0,1,.7-3.53c.74-1,1.74-1.83,2.42-2.88,2.18-3.34.7-7.73-.12-11.64-1.77-8.35-.13-17.07-1.25-25.53-.38-2.85-1.07-5.65-1.62-8.48a173.29,173.29,0,0,1-2.31-20.22c-.72-9.68-3.41-19.22-1.87-28.82a111.93,111.93,0,0,0,.95-17,74,74,0,0,0-.47-10.84c-.39-2.68-1.08-5.31-1.38-8a72.52,72.52,0,0,1-.16-9.09,89.92,89.92,0,0,0-1.86-20.12c-2-9.09-5.76-17.79-7.36-26.9.54.12,1.08.24,1.6.38.06-7-6.07-22.22-8.34-28.86a8.39,8.39,0,0,1-.6-2.55,27.51,27.51,0,0,1,.63-3.43c.29-2.42-1-4.72-1.35-7.14a16.75,16.75,0,0,1,.37-5.08c1.61-8.95,3.61-17.83,5.61-26.7a28.44,28.44,0,0,0,.89-9.87,12.39,12.39,0,0,1,3-9.83,11.66,11.66,0,0,0,2.22-2.79,7.08,7.08,0,0,0,.44-2.79,44.83,44.83,0,0,0-1.8-12.15c1.76-3.19,2.41-7.11,2.92-10.81,1.12-8.17,2.24-16.38,2.2-24.63a41.75,41.75,0,0,0-1.8-13,51.59,51.59,0,0,0-3.42-7.54c-5.26-10.13-10.29-20.79-16.93-30.07-2-2.82-.74-6.71-.6-10.19.15-4.2-1.51-8.23-3.14-12.09a19.84,19.84,0,0,0-3.76-6.47,6.11,6.11,0,0,0-4.4-2,6.63,6.63,0,0,0-4.69,2.87,15.47,15.47,0,0,0-2.81,11.57,22.37,22.37,0,0,0,5.09,10.93,24.77,24.77,0,0,0,4.39,4.17q2.48,7.88,5,15.75c2.64,8.35,5.28,16.74,9,24.64,1.09,2.29,2.29,4.62,2.42,7.15.14,2.73-1,5.33-1.91,7.9a55.75,55.75,0,0,0-3.22,16.66,5.73,5.73,0,0,0-.84.46c-3.15,2.06-4.14,6.55-7.42,8.39-1.91,1.07-4.23,1-6.37,1.49-.19,0-.38.1-.58.16-.08-.4-.16-.79-.21-1.2a3.23,3.23,0,0,1,0-.77,33.59,33.59,0,0,0,12.43-11.84,10.83,10.83,0,0,0,1.47-3,11.6,11.6,0,0,0,.15-3.9,62.24,62.24,0,0,0-1.85-12.85,21.37,21.37,0,0,0-6.69-10.89c-1.64-1.32-3.53-2.31-5.16-3.64-3.18-2.57-5.36-6.37-9-8.28A10.83,10.83,0,0,0,980,444.12a7.89,7.89,0,0,1-2,2.54,20.55,20.55,0,0,0-1.86,1c-1.1.88-1.16,2.57-.8,3.94a41,41,0,0,1,1.14,8.59,21,21,0,0,0-.06,27.17c0,1.86,0,3.72-.07,5.58,0,.35,0,.71-.07,1.06a7.21,7.21,0,0,1-3-2c-1.12-1.4-1.32-3.46-2.69-4.61a7.59,7.59,0,0,0-3.28-1.2,20.37,20.37,0,0,1-8-3.79c-1.85-1.43-3.77-3.26-5.93-3.68a131.57,131.57,0,0,0-13-19.84,38.65,38.65,0,0,1-3.4-4.67c-2.15-3.75-2.79-8.16-4.15-12.27-3.8-11.52-13.28-20.76-15.59-32.68-.84-4.32-3.58-8.08-5.46-12.06-1.27-2.69-2.67-5.53-5.21-7.07-3.27-2-7.79-1.08-10.51,1.61A12.63,12.63,0,0,0,892.81,402.37Zm118.73,404.69a8.84,8.84,0,0,1-3.82,1,18.43,18.43,0,0,0-2,.32c-.25-2.1-.39-4.23-.55-6.3-.53-6.79-1.59-13.53-2.64-20.26-1.1-7-1.62-14.66-4-21.38-3.83-10.94-7.71-22.21-7.22-33.8.11-2.63.44-5.24.58-7.86.32-6.49-.59-13.12,1-19.43.71-2.87,1.92-5.61,2.38-8.53a40.49,40.49,0,0,0,.1-7.94,105.53,105.53,0,0,1,2.27-27.35c1.86,2.43,2.47,5.57,3,8.58l3.75,20.34c2.23,12.07,4.2,24.87,10.11,35.61-.83,3.87-1.65,8-.28,11.7.59,1.6,1.56,3,2.16,4.62,1,2.69.86,5.65,1.16,8.5.65,6,3.13,11.9,1.31,17.69a86.29,86.29,0,0,0-3.63,18.36,44.71,44.71,0,0,1-.6,5.17c-.32,1.54-.84,3-1.13,4.58a15.17,15.17,0,0,0,.29,6.67,13.62,13.62,0,0,1,.82,3.75c0,1.28-1.57,2.2-2.83,2.4.37.48.77.94,1.18,1.39A4.38,4.38,0,0,1,1011.54,807.06Z"
			transform="translate(-43.21 -57.79)"
			fill="url(#e697e668-bf6d-4d5c-9412-9fae30629717)"
		/>
		<path
			d="M972.05,818.6a8.09,8.09,0,0,0-4.37,1.42,6.16,6.16,0,0,0-1.82,3.32,8.88,8.88,0,0,0,1.2,7.42,8.33,8.33,0,0,0,3.39,2.53c4.62,2,9.92.54,14.74-.91l18.88-5.68a6.34,6.34,0,0,0,3.07-1.59,4.17,4.17,0,0,0,.08-4.86,9.44,9.44,0,0,0-4-3.19c-5.87-2.86-12.49-3.51-18.94-3.63-2.4,0-4.77-.58-6.4,1.27-.86,1-.7,2.07-2,2.92A9,9,0,0,1,972.05,818.6Z"
			transform="translate(-43.21 -57.79)"
			fill="#3f3d56"
		/>
		<path
			d="M1007.72,808.22a8.17,8.17,0,0,0-4.37,1.42,6.2,6.2,0,0,0-1.82,3.32,8.91,8.91,0,0,0,1.2,7.43,8.4,8.4,0,0,0,3.39,2.52c4.63,2,9.92.55,14.74-.9l18.88-5.69a6.34,6.34,0,0,0,3.07-1.59,4.16,4.16,0,0,0,.08-4.85,9.47,9.47,0,0,0-4-3.19c-5.88-2.86-12.5-3.52-18.95-3.64-2.4,0-4.76-.57-6.4,1.28-.86,1-.7,2.06-2,2.91A8.7,8.7,0,0,1,1007.72,808.22Z"
			transform="translate(-43.21 -57.79)"
			fill="#3f3d56"
		/>
		<path
			d="M991.31,603.32a232.59,232.59,0,0,1,33.49-.94,6.66,6.66,0,0,1,2.17.34c2.46,1,2.84,4.22,3.07,6.85,1,10.68,5.66,20.63,8,31.09a88.83,88.83,0,0,1,1.86,20,71.72,71.72,0,0,0,.16,9c.3,2.67,1,5.29,1.38,7.95a73,73,0,0,1,.47,10.77,110.49,110.49,0,0,1-.95,16.87c-1.54,9.53,1.15,19,1.87,28.64A170.93,170.93,0,0,0,1045.1,754c.55,2.81,1.24,5.59,1.62,8.42,1.12,8.41-.52,17.07,1.25,25.37.82,3.88,2.3,8.24.12,11.56-.68,1-1.68,1.85-2.42,2.86a3.57,3.57,0,0,0-.7,3.51c.43.91,1.43,1.51,1.68,2.48.39,1.53-1.21,2.78-2.65,3.43-10.85,4.9-24.84,1.45-32.16-7.94,1.26-.2,2.8-1.11,2.83-2.39a13.5,13.5,0,0,0-.82-3.72,15,15,0,0,1-.29-6.62c.29-1.54.81-3,1.13-4.55a44.2,44.2,0,0,0,.6-5.14,85.21,85.21,0,0,1,3.63-18.24c1.82-5.75-.66-11.57-1.31-17.57-.3-2.84-.17-5.77-1.16-8.45-.6-1.58-1.57-3-2.16-4.58-1.37-3.69-.55-7.79.28-11.63-5.91-10.67-7.88-23.39-10.11-35.38l-3.75-20.2c-.56-3-1.17-6.11-3-8.53a104.16,104.16,0,0,0-2.27,27.17,40,40,0,0,1-.1,7.89c-.46,2.9-1.67,5.63-2.38,8.47-1.55,6.27-.64,12.85-1,19.3-.14,2.61-.47,5.2-.58,7.81-.49,11.52,3.39,22.72,7.22,33.59,2.35,6.67,2.87,14.25,4,21.23,1,6.69,2.11,13.38,2.64,20.13.49,6.2.71,12.91,4.57,17.78-3.53,2.29-7.17,4.62-11.3,5.41a20.86,20.86,0,0,1-13.92-2.7,43.79,43.79,0,0,1-11-9.35c.81-.28,1.1-1.46,1.18-2.31,1.2-12.66-3.61-25-5.43-37.6a81,81,0,0,1-.48-19.06c.23-2.39.56-4.78.65-7.18.48-12.51-5.55-24.56-5.33-37.08.1-5.87-3-11.65-4.52-17.32-1.31-5-1.35-10.3-1.38-15.5l-.25-41c0-5.54,0-11.22,1.79-16.45,2.2-6.3-.32-13.53-.7-20.19A83.22,83.22,0,0,0,991.31,603.32Z"
			transform="translate(-43.21 -57.79)"
			fill="#696791"
		/>
		<path
			d="M955.66,485.52a130.66,130.66,0,0,0-15.31-24.17,38.33,38.33,0,0,1-3.4-4.64c-2.15-3.73-2.79-8.11-4.15-12.19-3.8-11.44-13.28-20.63-15.59-32.46-.84-4.3-3.58-8-5.46-12-1.27-2.67-2.67-5.49-5.21-7-3.27-2-7.79-1.08-10.51,1.6a12.49,12.49,0,0,0-3.22,10.55,8.93,8.93,0,0,0,2,4.74c1.45,1.63,3.62,2.37,5.57,3.35a21.88,21.88,0,0,1,10.76,12.29c3.33,9.65,3.76,19.87,8,29.19s9.22,18.26,12.88,27.79c2.08,5.41,3.74,11,6.79,16s7.81,9.19,13.56,9.94A33.45,33.45,0,0,1,954,497.83C955.25,493.89,957.47,489.25,955.66,485.52Z"
			transform="translate(-43.21 -57.79)"
			fill="#a0616a"
		/>
		<path
			d="M1017.57,493a55.26,55.26,0,0,1,3.25-20.78c.92-2.55,2-5.14,1.91-7.85-.13-2.52-1.33-4.83-2.42-7.11-3.76-7.85-6.4-16.17-9-24.47l-5-15.65a24.31,24.31,0,0,1-4.39-4.15,22.1,22.1,0,0,1-5.09-10.86,15.25,15.25,0,0,1,2.81-11.48,6.65,6.65,0,0,1,4.69-2.86,6.14,6.14,0,0,1,4.4,2,19.71,19.71,0,0,1,3.76,6.42c1.63,3.84,3.29,7.84,3.14,12-.14,3.46-1.43,7.32.6,10.13,6.64,9.22,11.67,19.81,16.93,29.88a50.56,50.56,0,0,1,3.42,7.49,41.19,41.19,0,0,1,1.8,12.94c0,8.19-1.08,16.35-2.2,24.47-.71,5.09-1.64,10.63-5.49,14C1026.69,502,1022.67,497,1017.57,493Z"
			transform="translate(-43.21 -57.79)"
			fill="#a0616a"
		/>
		<circle cx="948.92" cy="418.36" r="20.75" fill="#a0616a" />
		<path
			d="M1002.18,498c.5,3.75,2.51,7.11,4.47,10.35,1.18,2,2.69,4.13,5,4.35a100.79,100.79,0,0,1-18.85,7.58,21.32,21.32,0,0,1-6.88,1.11,16.83,16.83,0,0,1-5.73-1.47A28.49,28.49,0,0,1,964,501a37.6,37.6,0,0,0,7.71-.59,5.67,5.67,0,0,0,3.78-1.86,6,6,0,0,0,.78-3.34c.1-3.46.11-6.93,0-10.39a41,41,0,0,1,15.08,1.86c2,.65,4,1.43,6,1.94,1.26.32,4.73,0,5.66.73C1004.54,490.38,1001.83,495.45,1002.18,498Z"
			transform="translate(-43.21 -57.79)"
			fill="#a0616a"
		/>
		<path
			d="M993.06,510.61A13.06,13.06,0,0,1,1003,499c2.14-.48,4.46-.42,6.37-1.48,3.28-1.83,4.27-6.29,7.42-8.34s7.62-.91,10.36,1.68,4.13,6.28,5.25,9.89a50.06,50.06,0,0,1,2.69,15.15,7,7,0,0,1-.44,2.77,11.56,11.56,0,0,1-2.22,2.77,12.26,12.26,0,0,0-3,9.77,28,28,0,0,1-.89,9.8c-2,8.82-4,17.63-5.61,26.53a16.47,16.47,0,0,0-.37,5c.31,2.41,1.64,4.69,1.35,7.1a26.87,26.87,0,0,0-.63,3.41,8.27,8.27,0,0,0,.6,2.53c2.27,6.59,8.4,21.69,8.34,28.67-10.65-2.73-26.35-3.34-37.35-3.39a83.11,83.11,0,0,0-9.06.4c-7.23.78-14.63,2.89-21.64.94-6.51-1.81-12.27-7-19-6.35-1.46-3.82.26-16.57,1.63-20.43a87.44,87.44,0,0,0,3-47.33c-1.23-5.66.46-11.67-.91-17.29a10.31,10.31,0,0,0-1.5-3.73,4,4,0,0,0-3.42-1.79,127.39,127.39,0,0,1,2.5-26.93c.66-3.15,2-6.87,5.23-7.41,2.86-.49,5.26,1.93,7.56,3.7a20.31,20.31,0,0,0,8,3.76,7.59,7.59,0,0,1,3.28,1.2c1.37,1.14,1.57,3.19,2.69,4.58,2,2.49,6.47,2.28,7.89,5.15a19.61,19.61,0,0,1,.75,2.62,9.62,9.62,0,0,0,3.3,4.26A18.56,18.56,0,0,0,993.06,510.61Z"
			transform="translate(-43.21 -57.79)"
			fill="#f86d70"
		/>
		<path
			d="M975.27,454.09c-.36-1.37-.3-3,.8-3.92.55-.43,1.27-.59,1.86-1a8,8,0,0,0,2-2.53,10.86,10.86,0,0,1,13.59-3.45c3.61,1.89,5.79,5.67,9,8.22,1.63,1.32,3.52,2.3,5.16,3.62a21.21,21.21,0,0,1,6.69,10.82,61.39,61.39,0,0,1,1.85,12.76,11.48,11.48,0,0,1-.15,3.88,10.86,10.86,0,0,1-1.47,3c-3.3,5-7.65,9.54-13.1,12.12s-12.08,3-17.46.3a3,3,0,0,1-1.34-1.07,3.85,3.85,0,0,1-.21-2.31,15.81,15.81,0,0,0-1.74-8.85c-1-2-2.5-3.72-3.3-5.79a20.17,20.17,0,0,1-.94-7.18C976.42,466.42,976.85,460.15,975.27,454.09Z"
			transform="translate(-43.21 -57.79)"
			fill="#2d293d"
		/>
	</svg>
);
